import { useMemo, useContext, useEffect } from 'react';
import { Promise } from 'bluebird';

import {
  triggerMultiStepTeachingBubbleWithLock,
  MultiStepTeachingBubbleContext,
} from '@bingads-webui-campaign-react/multi-step-teaching-bubble';

import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { couponTeachingBubbleConfig, couponTeachingBubbleOldUIConfig } from './coupon-teachingbubble-config';

export const CouponTeachingBubbleRenderer = ({ aid, permissions }) => {
  const isNavigationRefreshEnabled = isNavigationRefreshOn(permissions);
  const bubbleContext = useContext(MultiStepTeachingBubbleContext);
  const isInAccountScope = useMemo(() => !!(aid > 0), [aid]);

  const { data: couponList = [], loading: couponDataLoading } = useJsData(
    jsData => (isInAccountScope ? jsData.FeatureAdoptionCoupon.findAll({ aid }) : Promise.resolve([])), [aid]
  );

  const trigger = useMemo(() => {
    if (isInAccountScope && !couponDataLoading && couponList.filter(coupon => coupon.Status === 0).length > 0) {
      return true;
    }

    return false;
  }, [couponList, couponDataLoading, isInAccountScope]);

  useEffect(() => {
    if (trigger) {
      if (isNavigationRefreshEnabled) {
        triggerMultiStepTeachingBubbleWithLock({
          ...bubbleContext,
          featureName: couponTeachingBubbleConfig.featureName,
        });
      } else {
        triggerMultiStepTeachingBubbleWithLock({
          ...bubbleContext,
          featureName: couponTeachingBubbleOldUIConfig.featureName,
        });
      }
    }
  }, [trigger, bubbleContext, isNavigationRefreshEnabled]);

  return null;
};
